var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50163 10.8359H4.16829C3.28424 10.8359 2.43639 11.1871 1.81127 11.8122C1.18615 12.4374 0.834961 13.2852 0.834961 14.1693V15.8359M17.2517 12.0027L16.5017 11.7527M11.835 9.91935L11.085 9.66935M13.0016 13.9191L13.2516 13.1691M15.0849 8.50244L15.3349 7.75244M15.5016 13.9194L15.1683 13.0861M13.1683 8.58577L12.835 7.75244M11.085 12.1694L11.9183 11.8361M16.4183 9.83586L17.2516 9.50252M16.6683 10.8359C16.6683 12.2166 15.549 13.3359 14.1683 13.3359C12.7876 13.3359 11.6683 12.2166 11.6683 10.8359C11.6683 9.45523 12.7876 8.33594 14.1683 8.33594C15.549 8.33594 16.6683 9.45523 16.6683 10.8359ZM10.0016 4.16927C10.0016 6.01022 8.50924 7.5026 6.66829 7.5026C4.82734 7.5026 3.33496 6.01022 3.33496 4.16927C3.33496 2.32832 4.82734 0.835938 6.66829 0.835938C8.50924 0.835938 10.0016 2.32832 10.0016 4.16927Z",
    stroke: "#71717A",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsUser);
export default __webpack_public_path__ + "static/media/settings_user.9e409f797318085a1fe7fc94ad2e640a.svg";
export { ForwardRef as ReactComponent };